import { Injectable } from '@angular/core';
import { BaseStoreServiceInterface } from '../../shared/interfaces/base-store-service.interface';

@Injectable({ providedIn: 'root' })
export class BaseLocalStorageService implements BaseStoreServiceInterface {
  set<T>(key: string, value: T): void {
    if (typeof value === 'string') {
      localStorage.setItem(key, value);
    } else {
      localStorage.setItem(key, JSON.stringify(value));
    }
  }

  get<T>(key: string): T | string | null {
    const rawValue = localStorage.getItem(key);

    if (rawValue === null) {
      return null;
    }

    const valueString = rawValue.trim();
    const isJson =
      (valueString.startsWith('{') && valueString.endsWith('}')) ||
      (valueString.startsWith('[') && valueString.endsWith(']'));

    if (isJson) {
      try {
        return JSON.parse(valueString) as T;
      } catch {
        return valueString;
      }
    }

    return this.normalizeQuotes(valueString);
  }

  update<T extends object>(key: string, partial: Partial<T>): void {
    const current = this.get<T>(key);

    if (current && typeof current === 'object' && !Array.isArray(current)) {
      const updated = { ...current, ...partial };
      this.set(key, updated);
    } else {
      this.set(key, partial as T);
    }
  }

  delete(key: string): void {
    localStorage.removeItem(key);
  }

  normalizeQuotes(str: string): string {
    let s = str.trim();
    s = s.replace(/^[`'"]+|[`'"]+$/g, '');
    return `${s}`;
  }
}
